<template>
    <div class="file-upload">
        <input :ref="this.ident"
               :id="this.ident"
               :name="this.ident"
               :accept="this.accept"
               :class="this.defaultClass"
               :required="this.isRequired"
               :multiple="this.multiple"
               type="file">
    </div>
</template>

<script>
export default {
    name: "file-upload",

    props: [
        'ident',
        'isRequired',
        'type',
        'accept',
        'defaultClass',
        'route',
        'routeDelete',
        'preview',
        'multiple'
    ],

    data: function () {
        return {
            value: null,
            timeout: null,
            maxFiles: 18
        }
    },

    mounted: function () {
        this.$refs[this.ident].addEventListener('input', this.listener)
    },

    methods: {
        listener: function () {
            this.value = this.$refs[this.ident].files

            if (this.value.length > this.maxFiles) {
                alert('Lze mít nahraných jen ' + this.maxFiles + ' fotek k odhadu.')
                return
            }

            let parent = this.$refs[this.ident].parentElement
            let target = this.route
            let data = this.postData
            let self = this

            if (this.timeout) {
                clearTimeout(this.timeout)
                this.timeout = null
                parent.classList.remove("loading-spinner")
            }

            parent.classList.remove("error")
            parent.classList.remove("saved")
            parent.classList.add("loading-spinner");
            this.timeout = setTimeout(function () {
                let axios = require('axios');

                let config = {
                    method: 'post',
                    url: target,
                    data: data,
                    headers: { 'Content-Type': 'multipart/form-data' }
                };

                axios(config)
                    .then(function (response) {
                        parent.classList.remove("loading-spinner")
                        parent.classList.add("saved")

                        if (self.preview && response.data.success.length === 1) {
                            console.log(response.data.success)
                            document.getElementById(self.preview).style.backgroundImage =
                                "url('" + response.data.success[0] + "')"
                        } else if (self.preview && response.data.success.length > 1) {
                            let wrapper = document.getElementById(self.preview)
                            let images = response.data.success

                            wrapper.innerHTML = "";

                            try {
                                images.forEach(function (image) {
                                    let div = document.createElement('div')
                                    div.classList.add('col-4')
                                    div.classList.add('p-2')

                                    let subDiv = document.createElement('div')
                                    subDiv.classList.add('bg-ratio')
                                    subDiv.classList.add('bg-ratio--3-2')
                                    subDiv.style.backgroundImage = "url('" + image.file + "')"

                                    let deleteButton = document.createElement('button')
                                    deleteButton.classList.add('close')
                                    deleteButton.innerHTML = '&times;'
                                    deleteButton.onclick = function (event) {
                                        event.preventDefault();

                                        let parent = event.target.parentElement.parentElement
                                        let target = self.routeDelete
                                        let data = {
                                            'ident': image.name,
                                            'value': image.value
                                        }

                                        let axios = require('axios');

                                        let config = {
                                            method: 'post',
                                            url: target,
                                            data: data,
                                        };

                                        console.log (axios, config)

                                        axios(config)
                                            .then(function (response) {
                                                parent.remove()
                                            })
                                            .catch(function (error) {
                                                console.log(error)
                                            });
                                    }

                                    subDiv.appendChild(deleteButton)
                                    div.appendChild(subDiv)
                                    wrapper.appendChild(div)
                                })
                            } catch(e) {}
                        }
                    })
                    .catch(function (error) {
                        parent.classList.remove("loading-spinner")
                        parent.classList.add("error")
                        console.log(error)
                    });
            }, 2000)
        },
    },

    computed: {
        postData: function () {
            let data = new FormData();
            for (var i = 0; i < this.value.length; i++) {
                data.append('files[' + i + ']', this.value[i])
            }
            data.append('name', this.ident)

            return data
        }
    },
}
</script>

<style scoped>
    .file-upload {
        position: initial !important;
    }

    .file-upload:before {
        top: calc(50% - 45px) !important;
        right: 0 !important;
    }
</style>
